import {searchReportHTML, searchReport, searchReportById} from '../reports/reports.api';

// #region Globals
const CONTEXT_BASE_PATH = 'playas/pdf';
const CONTEXT_BASE_HTML_PATH = 'playas/html';
const CONTEXT_SINGLE_BASE_PATH = 'playas/pdfindividual';
// #endregion

// #region Public functions
async function getBeachPdf(id) {
  return searchReportById(id, CONTEXT_SINGLE_BASE_PATH);
}
async function searchBeachPdf(searchParams = {}) {
  return searchReport(searchParams, CONTEXT_BASE_PATH);
}
async function searchBeachHtml(searchParams = {}) {
  return searchReportHTML(searchParams, CONTEXT_BASE_HTML_PATH);
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  getBeachPdf,
  searchBeachPdf,
  searchBeachHtml,
};
